export default __webpack_public_path__ + "static/media/essential.51c3e07c.svg";